<template>
  <xml-import-logs-dashboard></xml-import-logs-dashboard>
</template>

<script>
import XmlImportLogsDashboard from '../../../components/XmlImportLogs/XmlImportLogsDashboard.vue';

export default {
  components: {XmlImportLogsDashboard},
};
</script>
